<template>
  <div class="home">
    <img src="@/assets/imgs/product_logo.png" alt />
    <!-- <span>即将开放</span> -->
  </div>
</template>

<script>
import { toGateway } from "../gateway";
import { consume, cuCodeRex } from "../auth/location";
export default {
  data() {
    return {
      resData: {},
      count: 0,
      login: "",
      userType: "",
    };
  },
  // created() {
  //   setTimeout(() => {
  //     this.$router.push('/login')
  //   },1000)
  // },
  async created() {
    try {
      const language = localStorage.getItem("language") || "CN";
      localStorage.setItem("language", language);
      localStorage.setItem("hidePatientLogin", false);
      let code = this.$route.query.code;
      if (!code) {
        console.log("没有code");
        return;
      }
      this.$authAjax
        .post(`/api/wxapp/getInfoByCache?code=${code}`)
        .then((res) => {
          let resData = res.data;
          if (resData.code == 200) {
            let locationId = resData.data.locationId;
            localStorage.setItem("shopId", resData.data.shopId);
            // localStorage.setItem("customerId", resData.data.customerId);
            localStorage.setItem("homeUrl", resData.data.homeUrl);
            localStorage.setItem("locationId", locationId || "");
            sessionStorage.setItem("token", resData.data.accessToken);
            localStorage.setItem("wxOpenId", resData.data.wxOpenId);
            localStorage.setItem("env", resData.data.env);
            localStorage.setItem(
              "customerInfoList",
              JSON.stringify(resData.data.customerInfoList)
            );
            let customerId, phone;
            // if (locationId) {
            //   this.checkWhetherAllowed();
            // }
            if (
              resData.data.customerInfoList &&
              resData.data.customerInfoList.length > 0
            ) {
              localStorage.setItem(
                "userName",
                resData.data.customerInfoList[0].username
              );
              customerId = resData.data.customerInfoList[0].customerId;
              phone = resData.data.customerInfoList[0].phone;
            }
            this.login = resData.data.login;
            this.userType = resData.data.userType;
            if (resData.data.login == "1" && resData.data.userType == "1") {
              this.goUrl("/page");
            } else {
              const locationId = localStorage.getItem("locationId");
              if (locationId == "8") {
                this.goUrl("/login?type=1");
              } else {
                this.goUrl("/login");
              }
            }
          }
        });
      if (process.env.NODE_ENV != "production") {
        localStorage.setItem("shopId", this.$route.query.shopId);
        localStorage.setItem("customerId", this.$route.query.customerId);
        this.goUrl("/page");
      }
    } catch (error) {
      // this.goUrl("/login");
    }
  },
  methods: {
    // 检查是否允许点餐
    checkWhetherAllowed() {
      try {
        const locationId = localStorage.getItem("locationId");
        const shopId = localStorage.getItem("shopId");
        const roles = JSON.parse(localStorage.getItem("customerInfoList"));
        const customerId =
          (roles && roles[0] && roles[0].customerId) ||
          localStorage.getItem("customerId");
        let data = {
          shopId,
          customerId,
          levelNo: locationId,
        };
        this.$authAjax
          .post("/api/wxapp/customer/checkReserve/byLevelNo", data)
          .then((res) => {
            const resData = res.data;
            console.log(resData, 126666666);
            if (resData.code == 200) {
              const allowReserve = resData.data.allowReserve;
              console.log(allowReserve, "allowReserve");
              // 不显示患者登录
              if (allowReserve) {
                localStorage.setItem("hidePatientLogin", true);
              }
            }
          });
      } catch (error) {
        console.log(error, "error");
      }
    },
    goUrl(path) {
      setTimeout(() => {
        this.$router.replace(path);
      }, 1500);
    },
    //注册
    getRegiste() {
      this.$authAjax
        .post("/api/wxapp/h5Customer/account/register")
        .then((res) => {
          let resData = res.data;
          localStorage.setItem("customerId", resData.data.customerId);
          if (resData.data.userStatus == "1") {
            const isTo = toGateway();
            if (!isTo) {
              this.goUrl("/page");
            }
          } else {
            this.goUrl("/login");
          }
        });
    },
    // handleClickHome() {
    //   this.count++;
    //   if (this.count == 6 && this.login == "1" && this.userType == "1") {
    //     this.getRegiste();
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 180px;
    height: 70px;
    margin-top: -100px;
    display: block;
    object-fit: cover;
  }

  span {
    color: #666;
    font-size: 30px;
    margin-top: 20px;
  }
}
</style>
